import { Country } from "@/helpers/generateSiteMap";
import { generateSlug } from "@/helpers/generateSlug";
import { Link, usePathname } from "@/i18n/navigation";
import { cn } from "@/lib/utils";
import { ArrowUpRight } from "lucide-react";
import { useTranslations } from "next-intl";
import Image from "next/image";

interface PropsType {
  country: Country;
  className?: string;
  onClick?: () => void;
}

const cardClassName =
  "group flex justify-between rounded-lg border border-transparent bg-muted px-[1.06rem] py-[0.94rem] transition-all hover:scale-105 hover:border-primary hover:bg-background hover:shadow-2xl dark:bg-card";

function StartingPriceCard({ country, className, onClick }: PropsType) {
  const t = useTranslations("Shared.countriesWithStartingPrice");
  const pathName = usePathname();
  const countrySlug =
    country.slug || generateSlug(country.name).replace(/-esim$/, "");
  const href = pathName.includes("/data-voice-sms/")
    ? `/esim/${countrySlug}/?package_type=data-voice`
    : `/esim/${countrySlug}/`;

  const content = (
    <>
      <div className="flex items-center gap-3">
        <div className="relative h-[42px] w-[42px]">
          <Image
            src={country.image_url}
            alt={`${country.name} flag`}
            sizes="auto"
            fill
            className="shrink-0 rounded-full object-cover"
          />
        </div>
        <div className="flex flex-col justify-center">
          <h3 className="text-body-base font-500">{country.name}</h3>
          {country.starts_at && (
            <p className="text-sm">
              {t("startsAt")} ${country.starts_at}
            </p>
          )}
        </div>
      </div>
      <div>
        <ArrowUpRight className="group-hover:rotate-45 group-hover:text-primary" />
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(cardClassName, "w-full text-start", className)}
      >
        {content}
      </button>
    );
  }

  return (
    <Link className={cn(cardClassName, className)} href={href}>
      {content}
    </Link>
  );
}

export default StartingPriceCard;
